<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {
                      title: 'Dashboard',
                      url: 'dashboard'
                    },
                    {
                      title: 'Link 1',
                      url: 'link-1'
                    },
                    {
                      title: 'Link 2',
                      url: 'link-1'
                    },
                    {
                      title: 'Active',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">Question Bank</h3>
            </div>

            <div class="form-group form-row text-dark">
              <div class="col-sm-8">
                <vs-input icon="search" placeholder="Search Training Name" v-model="search" />
              </div>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <!-- <div class="row col-sm-12">
            <label class="col-sm-1 font-weight-bold">Title:</label>
            <div class="col-sm-11">Global Training for prevention techniques against drug</div>
              </div>-->
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Start Date:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">22-7-2019</p>

                <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                <p class="col-sm-4 p-0">27-7-2019</p>
              </div>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Question Bank Information</h6>
              <div class="row col-sm-12">
                <vs-select
                  class="col-md-12 col-lg-12 font-weight-bold"
                  label="Category"
                  v-model="select9"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in categorytitleArr"
                  />
                </vs-select>
              </div>
              <div class="col-sm-6" v-if="select9 === 1 | select9 === 2">
                <label
                  style="padding-left: 5px;font-size:.85rem;"
                  class="font-weight-bold"
                >Thematic Area</label>
                <selectize
                  id="select-state"
                  v-model="thematicAreaSelected"
                  :settings="thematicAreaSettings"
                >
                  <option :value="1">Front end</option>
                  <option :value="2">Back end</option>
                  <option :value="3">Programming</option>
                  <option :value="4">Android</option>
                </selectize>
              </div>

              <div class="row col-sm-6" v-if="select9 === 1 | select9 === 2">
                <vs-select class="col-md-12 col-lg-12 font-weight-bold" label="Level">
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in leveltitleArr"
                  />
                </vs-select>
              </div>
            </div>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Question Bank Information</h6>

              <!-- <div class="row">-->

              <!-- <div class="col-sm-4">
            <div class="form-group">
              <label>No of Q's:</label>
              <select class="form-control" v-model="qusLimit">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
              </select>
            </div>
              </div>-->
              <div class="col-sm-12">
                <div class="col-sm-6" style="display:inline-flex;">
                  <label style="margin-right:10px;">
                    <b>Type:</b>
                  </label>
                  <div class="form-check">
                    <vs-radio v-model="radiostype" vs-name="type" vs-value="checkbox">Checkbox</vs-radio>
                  </div>
                  <div class="form-check">
                    <vs-radio v-model="radiostype" vs-name="type" vs-value="radios">Radios</vs-radio>
                  </div>
                </div>
                <div v-if="radiostype == 'checkbox'" class="col-sm-6" style="display:inline-flex;">
                  <label style="margin-right:10px;">
                    <b>No:</b>
                  </label>
                  <div style="margin-right:10px;" class="form-check">
                    <vs-radio v-model="numbertype" vs-name="numbering" vs-value="alphabet">A-E</vs-radio>
                  </div>
                  <div class="form-check">
                    <vs-radio v-model="numbertype" vs-name="numbering" vs-value="number">1-5</vs-radio>
                  </div>
                </div>
              </div>

              <!-- <div class="form-group">
            <button @click="addQuestion()" class="form-control btn btn-primary">Add</button>
              </div>-->

              <div class="row col-sm-12">
                <template v-if="questions.length !== 0">
                  <div v-if="questions[currentQ].type === 'checkbox'" class="col-sm-12">
                    <div class="form-group">
                      <div class="form-group">
                        <p>{{questions[currentQ].no}}</p>
                        <input
                          type="text"
                          class="form-control"
                          v-model="questions[currentQ].question"
                          placeholder="Please Enter your question"
                        />
                      </div>
                      <div class="form-group">
                        <div class="form-check">
                          <label class="form-check-label">
                            <li>
                              <vs-checkbox
                                :value="questions[currentQ].answer1"
                                v-model="questions[currentQ].correct"
                                style="margin-bottom:8px"
                              >
                                <input
                                  type="text"
                                  class="form-control mb-2"
                                  v-model="questions[currentQ].answer1"
                                  placeholder="Answer 1"
                                />
                              </vs-checkbox>
                            </li>

                            <!-- <input
                          type="checkbox"
                          :value="questions[currentQ].answer1"
                          v-model="questions[currentQ].correct"
                          class="form-check-input"
                            />-->
                            <!-- <input
                          type="text"
                          class="form-control mb-2"
                          v-model="questions[currentQ].answer1"
                          placeholder="Answer 1"
                            />-->
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <li>
                              <vs-checkbox
                                :value="questions[currentQ].answer1"
                                v-model="questions[currentQ].correct"
                                style="margin-bottom:8px"
                              >
                                <input
                                  type="text"
                                  class="form-control mb-2"
                                  v-model="questions[currentQ].answer1"
                                  placeholder="Answer 1"
                                />
                              </vs-checkbox>
                            </li>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <li>
                              <vs-checkbox
                                :value="questions[currentQ].answer1"
                                v-model="questions[currentQ].correct"
                                style="margin-bottom:8px"
                              >
                                <input
                                  type="text"
                                  class="form-control mb-2"
                                  v-model="questions[currentQ].answer1"
                                  placeholder="Answer 1"
                                />
                              </vs-checkbox>
                            </li>
                          </label>
                        </div>
                        <div class="form-check">
                          <label class="form-check-label">
                            <li>
                              <vs-checkbox
                                :value="questions[currentQ].answer1"
                                v-model="questions[currentQ].correct"
                                style="margin-bottom:8px"
                              >
                                <input
                                  type="text"
                                  class="form-control mb-2"
                                  v-model="questions[currentQ].answer1"
                                  placeholder="Answer 1"
                                />
                              </vs-checkbox>
                            </li>
                          </label>
                        </div>
                      </div>
                    </div>

                    <b-button
                      class="save-btn"
                      variant="primary"
                      v-if="currentQ+1 == questions.length"
                    >Submit</b-button>

                    <b-button v-else class="save-btn" variant="primary" @click="next()">Next</b-button>
                  </div>

                  <div v-if="questions[currentQ].type === 'radio'" class="col-sm-12">
                    <div class="form-group">
                      <div class="form-group">
                        <p>{{questions[currentQ].no}}</p>
                        <input
                          type="text"
                          class="form-control"
                          v-model="questions[currentQ].question"
                          placeholder="Please Enter your question"
                        />
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <!-- <template v-if="radios1 === 'Pre Training Form'">Pre Training Form</template> -->
                          <vs-radio
                            v-model="questions[currentQ].correct"
                            value="True"
                            class="form-check-input"
                            :name="'ques'+index"
                          >True</vs-radio>
                          <!-- <input
                        type="radio"
                        value="True"
                        v-model="questions[currentQ].correct"
                        class="form-check-input"
                        :name="'ques'+index"
                      />
                          True-->
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <vs-radio
                            v-model="questions[currentQ].correct"
                            value="false"
                            class="form-check-input"
                            :name="'ques'+index"
                          >False</vs-radio>
                          <!-- <input
                        type="radio"
                        value="False"
                        v-model="questions[currentQ].correct"
                        class="form-check-input"
                        :name="'ques'+index"
                      />
                          False-->
                        </label>
                      </div>
                    </div>
                    <b-button
                      class="save-btn"
                      variant="primary"
                      v-if="currentQ+1 == questions.length"
                    >Submit</b-button>

                    <b-button v-else class="save-btn" variant="primary" @click="next()">Next</b-button>
                  </div>
                </template>

                <!-- <pre>{{ correct }}</pre> -->
                <!-- <pre>{{ questions }}</pre> -->
              </div>
              <!-- new code for add questions starts(with text box alphabet) -->
              <template v-if="radiostype == 'checkbox'">
                <div class="col-sm-12">
                  <div class="pt-2">
                    <input
                      type="text"
                      v-model="qCheckboxArr[0].question"
                      class="form-control"
                      placeholder="Write question here..."
                    />
                  </div>
                </div>
                <div v-if="numbertype == 'alphabet'" class="col-sm-12">
                  <!-- option 1 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class="mt-3">
                      <span class="p-2">A</span>
                    </div>
                    <div class="mt-2" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 1"
                        v-model="qCheckboxArr[0].option1"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                    </div>
                    <div class="mt-minus-5">
                      <vs-select class="selectExample" label v-model="select3">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options3"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 1 ends -->
                  <!-- option 2 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">B</span>
                    </div>
                    <div class="mt-minus-1" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 2"
                        v-model="qCheckboxArr[0].option2"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                    </div>
                    <div class="mt-minus-6">
                      <vs-select class="selectExample" label v-model="select4">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options4"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 2 ends -->
                  <!-- option 3 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">C</span>
                    </div>
                    <div class="mt-minus-2" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 3"
                        v-model="qCheckboxArr[0].option3"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                    </div>
                    <div class="mt-minus-7">
                      <vs-select class="selectExample" label v-model="select5">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options5"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 3 ends -->
                  <!-- option 4 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">D</span>
                    </div>
                    <div class="mt-minus-3" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 4"
                        v-model="qCheckboxArr[0].option4"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                    </div>
                    <div class="mt-minus-8">
                      <vs-select class="selectExample" label v-model="select6">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options6"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 4 ends -->
                  <!-- option 5 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">E</span>
                    </div>
                    <div class="mt-minus-4" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 5"
                        v-model="qCheckboxArr[0].option5"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 5" /> -->
                    </div>
                    <div class="mt-minus-9">
                      <vs-select class="selectExample" label v-model="select7">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options7"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 5 ends -->

                  <div class="d-flex justify-content-end" style="width: 100%;">
                    <button
                      type="button"
                      @click="submitQuestion()"
                      class="btn btn-primary btn-sm"
                    >Save</button>
                    <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                  </div>
                </div>

                <div v-else class="col-sm-12">
                  <!-- option 1 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class="mt-3">
                      <span class="p-2">1</span>
                    </div>
                    <div class="mt-2" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 1"
                        v-model="qCheckboxArr[0].option1"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 1" /> -->
                    </div>
                    <div class="mt-minus-5">
                      <vs-select class="selectExample" label v-model="select3">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options3"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 1 ends -->
                  <!-- option 2 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">2</span>
                    </div>
                    <div class="mt-minus-1" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 2"
                        v-model="qCheckboxArr[0].option2"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 2" /> -->
                    </div>
                    <div class="mt-minus-6">
                      <vs-select class="selectExample" label v-model="select4">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options4"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 2 ends -->
                  <!-- option 3 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">3</span>
                    </div>
                    <div class="mt-minus-2" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 3"
                        v-model="qCheckboxArr[0].option3"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 3" /> -->
                    </div>
                    <div class="mt-minus-7">
                      <vs-select class="selectExample" label v-model="select5">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options5"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 3 ends -->
                  <!-- option 4 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">4</span>
                    </div>
                    <div class="mt-minus-3" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 4"
                        v-model="qCheckboxArr[0].option4"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 4" /> -->
                    </div>
                    <div class="mt-minus-8">
                      <vs-select class="selectExample" label v-model="select6">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options6"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 4 ends -->
                  <!-- option 5 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class style="margin-top: -9px;">
                      <span class="p-2">5</span>
                    </div>
                    <div class="mt-minus-4" style="width:100%;">
                      <vs-input
                        class="inputx"
                        placeholder="Option 5"
                        v-model="qCheckboxArr[0].option5"
                      />
                      <!-- <input type="text" class="form-control" placeholder="Option 5" /> -->
                    </div>
                    <div class="mt-minus-9">
                      <vs-select class="selectExample" label v-model="select7">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options7"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 5 ends -->

                  <div class="d-flex justify-content-end" style="width: 100%;">
                    <button
                      type="button"
                      @click="submitQuestion()"
                      class="btn btn-primary btn-sm"
                    >Save</button>
                    <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                  </div>
                </div>
                {{qCheckboxArr[0]}}
              </template>

              <!-- new code for add questions ends (with text box alphabet) -->
              <!-- new code for add questions starts(with Radio button) -->

              <template v-else>
                <div class="col-sm-12">
                  <div class="pt-2">
                    <input
                      type="text"
                      v-model="qRadioArr[0].question"
                      class="form-control"
                      placeholder="Write question here..."
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <!-- option 1 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class="pt-2 mt-1">
                      <ul class="leftx">
                        <li>
                          <vs-radio v-model="radios2" vs-value="true">True</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class>
                      <vs-select class="selectExample" label v-model="select1">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options1"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 1 ends -->
                  <!-- option 2 starts -->
                  <div class="d-flex justify-content-between mb-3">
                    <div class="mt-minus-11">
                      <ul class="leftx">
                        <li>
                          <vs-radio color="danger" v-model="radios2" vs-value="false">False</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="mt-minus-10">
                      <vs-select class="selectExample" label v-model="select2">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item,index) in options2"
                        />
                      </vs-select>
                    </div>
                  </div>
                  <!-- option 2 ends -->

                  <div class="d-flex justify-content-end" style="width: 100%;">
                    <button
                      type="button"
                      @click="submitQuestion()"
                      class="btn btn-primary btn-sm"
                    >Save</button>
                    <!-- <button type="button" class="btn btn-primary btn-sm">Add New</button> -->
                  </div>
                </div>
                {{qRadioArr[0]}}
              </template>
              <!-- new code for add questions ends (with Radio button) -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";

import "bootstrap/dist/css/bootstrap.css";
// Import this component
import axios from "axios";
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    isSidebar: false,
    radiostype: "checkbox",
    numbertype: "alphabet",
    qCheckboxArr: [
      {
        question: "",
        option1: "",
        option2: "",
        option3: "",
        option4: "",
        option5: "",
        type: ""
      }
    ],
    qRadioArr: [
      {
        question: "",
        option1: "true",
        option2: "false",
        type: "checkbox"
      }
    ],
    currentQ: 0,
    select1: 1,
    select2: 1,
    select3: 1,
    select4: 1,
    select5: 1,
    select6: 1,
    value1: "",
    value2: "",
    value3: "",
    value4: "",
    value5: "",
    select7: 1,
    radios2: "true",
    correct: "",
    qusLimit: "",
    qusType: "",
    qusNo: "",
    questions: [],
    seen: true,
    radios1: "Pre Training Form",
    popupActivo: false,
    activeItem: 0,
    search: "",
    isForm: true,
    isFormData: false,
    selected: "",
    options1: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options2: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options3: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options4: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options5: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options6: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    options7: [
      { text: "Correct", value: 1 },
      { text: "Incorrect", value: 2 }
    ],
    thematicAreaSelected: "",
    thematicAreaSettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 3,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    levelSelected: "",
    levelSettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    
    trainingCheck: false,
    repeatedCheck: false,
    select1Normal: "",
    select9: "",
    categorytitleArr: [
      { text: "Pre Assessment", value: 1 },
      { text: "Post Assessment", value: 2 },
      { text: "General", value: 3 },
      { text: "Feedback", value: 4 }
    ],
    leveltitleArr: [
      { text: "Beginners", value: 6 },
      { text: "Intermediate", value: 7 },
      { text: "Difficult", value: 8 }
    ]
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
  },
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  watch: {
    radiostype(val) {
      if (val === "radios") {
        this.qRadioArr[0].question = "";
      } else {
        this.qCheckboxArr[0].option1 = "";
        this.qCheckboxArr[0].option2 = "";
        this.qCheckboxArr[0].option3 = "";
        this.qCheckboxArr[0].option4 = "";
        this.qCheckboxArr[0].option5 = "";
        this.qCheckboxArr[0].type = "";
        this.qCheckboxArr[0].question = "";
      }
    }
  },
  methods: {
    next: function() {
      if (this.currentQ + 1 < this.questions.length) {
        this.currentQ++;
      }
    },
    submitQuestion() {
      if (this.radiostype == "checkbox") {
        this.qCheckboxArr[0].type = this.numbertype;
        if (this.qCheckboxArr[0].question == "") {
          alert("Please type your question");
        } else if (
          (this.qCheckboxArr[0].option1 != "") &
          (this.qCheckboxArr[0].option2 != "") &
          (this.qCheckboxArr[0].option3 != "") &
          (this.qCheckboxArr[0].option4 != "") &
          (this.qCheckboxArr[0].option5 != "")
        ) {
          alert("Question added succesfully");
          this.qCheckboxArr[0].question = "";
          this.qCheckboxArr[0].option1 = "";
          this.qCheckboxArr[0].option2 = "";
          this.qCheckboxArr[0].option3 = "";
          this.qCheckboxArr[0].option4 = "";
          this.qCheckboxArr[0].option5 = "";
          this.qCheckboxArr[0].type = "";
        } else {
          alert("Please type all your options");
        }
      } else {
        if (this.qRadioArr[0].question == "") {
          alert("Please type your question ");
        } else {
          this.qRadioArr[0].question = "";
          alert("Question added succesfully");
        }
      }
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    },
    addQuestion() {
      if (this.qusLimit == "") {
        alert("please select no of question");
      } else if (this.qusLimit == "") {
        alert("please select question type");
      } else {
        var loopLimit = this.questions.length;
        var number = "";
        for (
          let i = 0 + loopLimit;
          i < parseInt(this.qusLimit) + loopLimit;
          i++
        ) {
          if (this.qusNo == "alphabet") {
            number = (i + 10).toString(36) + " ";
          } else {
            number = i + 1;
          }
          if (this.qusType == "radio") {
            this.questions.push({
              question: "",
              answer1: "True",
              answer2: "False",
              correct: [],
              type: this.qusType,
              no: number
            });
          } else {
            this.questions.push({
              question: "",
              answer1: "",
              answer2: "",
              answer3: "",
              answer4: "",
              correct: [],
              type: this.qusType,
              no: number
            });
          }
        }
      }
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.material-icons {
  font-size: 16px;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.mt-minus-1 {
  margin-top: -18px;
}
.mt-minus-2 {
  margin-top: -18px;
}
.mt-minus-3 {
  margin-top: -17px;
}
.mt-minus-4 {
  margin-top: -17px;
}
.mt-minus-5 {
  margin-top: -2px;
}
.mt-minus-6 {
  margin-top: -28px;
}
.mt-minus-7 {
  margin-top: -28px;
}
.mt-minus-8 {
  margin-top: -28px;
}
.mt-minus-9 {
  margin-top: -28px;
}
.mt-minus-10 {
  margin-top: -27px;
}
.mt-minus-11 {
  margin-top: -15px;
}
.selectExample {
  margin: 10px 0px 10px 5px !important;
}
.con-select {
  width: 85px !important;
}
</style>


